module.exports = __webpack_public_path__ + "img/stuffed-flatbread.a73da109.png";